import * as Yup from "yup";


export const addCategoryValidator = () => {
    return Yup.object().shape({
       // zone_id: Yup.string().required("Zone is required."),
        patient_name: Yup.string().required("Patient name is required."),
        // age: Yup.string().required("Age name is required."),
        date_of_birth: Yup.string().required("DOB / Age is required."),
     //   address: Yup.string().required("Address is required."),
     //   area_id: Yup.string().required("Area is required."),
     //   city: Yup.string().required("City is required."),
     //   state_id: Yup.string().required("State is required."),
       // mobile: Yup.number().required("Mobile is required."),
       // email: Yup.string().email().required("Email is required."),
    //    weight: Yup.number().required("Weight is required."),
  //      height: Yup.number().required("Height is required."),
  //      LMP: Yup.number().required("LMP is required."),
    //    blood_group_id: Yup.string().required("Blood Group is required."),
      //  barcode_number: Yup.string().required("Barcode is required."),
        // collection_boy_id: Yup.string().required("Collection Boy Group is required."),
        // deliver_boy_id: Yup.string().required("Deliver Boy is required."),


         amount: Yup.string().required("Amount is required."),
        payment_mode_id: Yup.string().required("Payment Mode is required."),
    });
  }